import React from 'react'
import styled from 'styled-components'
import { UserPicture } from 'gipsy-ui'
import { styles } from 'gipsy-misc'

export default ({ contact }) => {
  return (
    <SuggestionContainer>
      <UserPicture
        backgroundColor="#e3e5e6"
        src={contact && contact.picture}
        size={32}
        style={{ marginRight: styles.spacings.small }}
      />
      <Info>
        <Name>{contact.displayName || contact.email}</Name>
        {contact && contact.email && contact.displayName && <Email>{`${contact.email}`}</Email>}
      </Info>
    </SuggestionContainer>
  )
}

const SuggestionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;
  cursor: pointer;
  padding: 7px;
  margin-bottom: 2px;
  border-radius: 4px;
  &:hover {
    background-color: white;
  }
`

const Info = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`

const Name = styled.div`
  color: ${styles.colors.textDarkColor};
  text-overflow: ellipsis;
  overflow: hidden;
`

const Email = styled.div`
  color: ${styles.colors.textLightColor};
  text-overflow: ellipsis;
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/features/teamlist/components/inviteUserInput/suggestion.js